// src/utils/watchCompanyRealtime.ts

import { onSnapshot, doc } from 'firebase/firestore'
import { getFirebaseDb } from '~/services/firebaseService'
import { COLLECTION_PERMISSIONS } from '@farmfree/common/constants/collections'
import { versionWatchers, type VersionKey } from '@/constants/versionWatchers'
import { loadVersionCache, saveVersionCache } from '@/utils/cache/versionCache'

let unsubscribeCompany: (() => void) | null = null

export function stopCompanyRealtimeWatcher() {
  if (unsubscribeCompany) {
    unsubscribeCompany()
    unsubscribeCompany = null
  }
}

export function watchCompanyRealtime(companyId: string) {
  // ✅ 이전 구독 해제
  if (unsubscribeCompany) {
    unsubscribeCompany()
    unsubscribeCompany = null
  }

  const companyDocRef = doc(getFirebaseDb(), COLLECTION_PERMISSIONS.company.name, companyId)

  let cachedVersions = loadVersionCache(companyId)
  console.log('🔍 캐시된 버전:', cachedVersions)

  unsubscribeCompany = onSnapshot(companyDocRef, async (snapshot) => {
    console.log('🔄 회사 정보 변경 감지')
    if (!snapshot.exists()) return

    const company = snapshot.data()
    console.log('📄 변경된 회사 정보:', company)

    for (const key of Object.keys(versionWatchers) as VersionKey[]) {
      const watcher = versionWatchers[key]
      const newVersion = company.versionInfo?.[key]
      const cachedVersion = cachedVersions[key]

      if (
        typeof newVersion === 'number' &&
        (cachedVersion === undefined || cachedVersion === null || newVersion !== cachedVersion)
      ) {
        const majorNew = Math.floor(newVersion)
        const majorCached = typeof cachedVersion === 'number' ? Math.floor(cachedVersion) : 0

        // store()가 async 함수이므로 await 필요
        const store = await watcher.store()

        if (majorNew !== majorCached) {
          console.log(`🔁 ${watcher.label} 스키마 변경 감지 → 전체 초기화`)
          await (store as any).syncFromScratch?.(company.id)
        } else {
          console.log(`🔄 ${watcher.label} 단순 변경 감지 → 변경 항목만 동기화`)
          await (store as any).syncWithServer?.(company.id)
        }

        cachedVersions[key] = newVersion
        saveVersionCache(companyId, { [key]: newVersion })
      }
    }
  })
}
